import { useState } from 'react';
import { BranchesDown, ListCheck, Person, EllipsisVertical } from '@gravity-ui/icons';
import { Button, DropdownMenu, Icon } from '@gravity-ui/uikit';

import { AdminTableAccounts } from './admin-table-accounts';
import { AdminTableEstablishments } from './admin-table-establishments';
import { AdminTableSections } from './admin-table-sections';
import { ACC_LIST_BTN, INSTITUTIONS_LIST, SECTIONS } from './constants';
import { useMediaQuery } from '@mui/material';
import { AccountListMenu } from './admin-table-accounts/sheets';

import styles from './styles.module.scss';

export const AdminMode = () => {
	const [activeComponent, setActiveComponent] = useState<string>('accounts');

	const isAdaptive = useMediaQuery('(max-width: 768px)');
	const isMobile = useMediaQuery('(max-width: 515px)');

	const renderActiveComponent = () => {
		switch (activeComponent) {
			case 'accounts':
				return <AdminTableAccounts isMobile={isMobile} />;
			case 'establishments':
				return <AdminTableEstablishments isMobile={isMobile} />;
			case 'sections':
				return <AdminTableSections isMobile={isMobile} />;
			default:
				return <AdminTableAccounts />;
		}
	};

	return (
		<div className={styles.admin_container}>
			{isAdaptive ? (
				<>
					{isMobile ? (
						<div className={styles.admin_dropdown}>
							<AccountListMenu setActiveComponent={setActiveComponent} />
						</div>
					) : (
						<div className={styles.admin_dropdown}>
							<DropdownMenu
								renderSwitcher={(props) => (
									<Button {...props} view="flat">
										<Icon size={20} data={EllipsisVertical} />
									</Button>
								)}
								size="xl"
								items={[
									{
										iconStart: <Icon size={16} data={Person} />,
										action: () => setActiveComponent('accounts'),
										text: 'Список аккаунтов',
										className:
											activeComponent === 'accounts'
												? `${styles.admin_panel__dropdown_item} ${styles.admin_panel__navigation_button_active} `
												: styles.admin_panel__navigation_button,
									},
									{
										iconStart: <Icon size={16} data={ListCheck} />,
										action: () => setActiveComponent('establishments'),
										text: 'Список учреждений',
										className:
											activeComponent === 'establishments'
												? `${styles.admin_panel__navigation_button} ${styles.admin_panel__navigation_button_active}`
												: styles.admin_panel__navigation_button,
									},
									{
										iconStart: <Icon size={16} data={BranchesDown} />,
										action: () => setActiveComponent('sections'),
										text: 'Разделы и подразделы',
										className:
											activeComponent === 'sections'
												? `${styles.admin_panel__navigation_button} ${styles.admin_panel__navigation_button_active}`
												: styles.admin_panel__navigation_button,
									},
								]}
							/>
						</div>
					)}
				</>
			) : (
				<div className={styles.admin_panel}>
					<Button
						size="l"
						// view="flat"
						// selected={activeComponent === 'accounts'}
						className={
							activeComponent === 'accounts'
								? `${styles.admin_panel__navigation_button} ${styles.admin_panel__navigation_button_active}`
								: styles.admin_panel__navigation_button
						}
						onClick={() => setActiveComponent('accounts')}
						view="flat"
					>
						<Icon data={Person} size={18} />
						{ACC_LIST_BTN}
					</Button>

					<Button
						size="l"
						// view="flat"
						// selected={activeComponent === 'establishments'}
						onClick={() => setActiveComponent('establishments')}
						className={
							activeComponent === 'establishments'
								? `${styles.admin_panel__navigation_button} ${styles.admin_panel__navigation_button_active}`
								: styles.admin_panel__navigation_button
						}
						view="flat"
					>
						<Icon data={ListCheck} size={18} />
						{INSTITUTIONS_LIST}
					</Button>
					<Button
						size="l"
						// view="flat"
						// selected={activeComponent === 'sections'}
						onClick={() => setActiveComponent('sections')}
						className={
							activeComponent === 'sections'
								? `${styles.admin_panel__navigation_button} ${styles.admin_panel__navigation_button_active}`
								: styles.admin_panel__navigation_button
						}
						view="flat"
					>
						<Icon data={BranchesDown} size={18} />
						{SECTIONS}
					</Button>
				</div>
			)}

			<div className={styles.accounts}>{renderActiveComponent()}</div>
		</div>
	);
};
